const {jQuery: $} = window;
import Utils from "../utils.class";

// API class
export default class ElementorInPageNavWidget {
    #elements = [];

    constructor(selector, offset) {
        Utils.log("Registered: Elementor InPageNav Widget");
        // Setup for on page load
        $(window).on("load", () => {
            $(selector).each((i, element) => {
                this.#elements.push(new ElementorInPageNav(element, offset));
            });
        });
    }

    get elements() {
        return this.#elements;
    }
}


class ElementorInPageNav {
    submenu;
    scrollSection;
    sections = [];
    isSticky = false;
    originalRect = null;
    originalDocumentTop = null; // Store the original document position
    stickyOffset;

    constructor(el, offset) {
        this.submenu = el;
        this.stickyOffset = offset;
        this.scrollSection = $(el).parents(".elementor-element").last()[0];

        if($(el).parent().is(this.scrollSection)) {
            $(el).addClass("js--sticky");
        } else {
            // Promote submenu container
            const $parents = $(el).parents(".elementor-element");
            $($parents[$parents.length - 2]).addClass("js--sticky");
        }

        this.init();
    }

    init() {
        // Store the original position FIRST, before any sticky behavior
        this.originalDocumentTop = this.getElementTop(this.submenu);

        // Auto-discover sections from anchor links
        this.discoverSections();

        if (this.sections.length === 0) {
            Utils.log('[InPageNav] No sections found');
            return;
        }

        // Set up all functionality
        this.setupSmoothScroll();
        this.setupStickyBehavior();

        $("body").addClass("js--hasInPageNav");

        Utils.log(`[InPageNav] Menu initialized with ${this.sections.length} sections`);
    }

    discoverSections() {
        const links = this.submenu.querySelectorAll('a[href^="#"]');

        links.forEach(link => {
            const targetId = link.getAttribute('href').substring(1);
            const targetElement = document.querySelector(`[data-menu='${targetId}'], #${targetId}`);

            if (targetElement) {
                this.sections.push({
                    element: targetElement,
                    link: link,
                    id: targetId
                });
            }
        });
    }

    setupStickyBehavior() {
        let scrollTimeout;

        window.addEventListener('scroll', () => {
            if (scrollTimeout) clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => this.handleSticky(), 10);
        }, { passive: true });
    }

    handleSticky() {
        const scrollTop = document.documentElement.scrollTop;

        // Use the stored original document position (calculated at page load)
        const menuOriginalTopInDocument = this.originalDocumentTop;

        // Get bottom of scroll section
        const scrollSectionBottom = this.getElementTop(this.scrollSection) + this.scrollSection.offsetHeight;

        // Make it disappear earlier - when we're getting close to the end of the scroll section
        const disappearOffset = 600; // Disappear 300px before the end of scroll-section

        // Should be sticky when:
        // 1. We've scrolled past the menu's original document position
        // 2. We haven't gotten close to the bottom of the scroll section
        const pastOriginalPosition = scrollTop >= (menuOriginalTopInDocument - this.stickyOffset);
        const beforeSectionEnd = scrollTop < (scrollSectionBottom - disappearOffset);

        const shouldBeSticky = pastOriginalPosition && beforeSectionEnd;

        // Update active link
        this.updateActiveLink(scrollTop, shouldBeSticky);
    }

    makeSticky() {
        Utils.log('[InPageNav] Make element sticky:', this.submenu);
        this.isSticky = true;

        // Preserve exact width and position
        this.submenu.style.width = this.originalRect.width + 'px';
        this.submenu.style.left = this.originalRect.left + 'px';

        this.submenu.classList.add('js--sticky');
    }

    removeSticky() {
        Utils.log('[InPageNav] Make element not sticky:', this.submenu);
        this.isSticky = false;

        // Clean up inline styles
        this.submenu.style.width = '';
        this.submenu.style.left = '';

        this.submenu.classList.remove('js--sticky');
    }

    setupSmoothScroll() {
        this.sections.forEach(({ link }) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const targetId = link.getAttribute('href').substring(1);
                const targetElement = document.querySelector(`[data-menu='${targetId}'], #${targetId}`);

                if (targetElement) {
                    const targetRect = targetElement.getBoundingClientRect();
                    const scrollTop = document.documentElement.scrollTop;
                    const targetPosition = targetRect.top + scrollTop - 120;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }

    updateActiveLink(scrollTop, shouldBeSticky) {
        let activeSection = null;

        this.sections.forEach(section => {
            const sectionTop = this.getElementTop(section.element);
            const sectionBottom = sectionTop + section.element.offsetHeight;
            const threshold = shouldBeSticky ? this.stickyOffset + 60 : 60;

            if (scrollTop >= (sectionTop - threshold) && scrollTop < (sectionBottom - threshold)) {
                activeSection = section;
            }
        });

        // Update active class
        this.sections.forEach(section => {
            section.link.classList.remove('js--active');
        });

        if (activeSection) {
            activeSection.link.classList.add('js--active');
        }
    }

    getElementTop(element) {
        let offsetTop = 0;

        while (element) {
            offsetTop += element.offsetTop;
            element = element.offsetParent;
        }

        return offsetTop;
    }
}